import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  outerContainer: {
    display: 'flex',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
  },
  innerContainer: ({ hasInnerPadding, isCentered }) => ({
    padding: '14px 30px',
    width: isCentered ? 'auto' : '100%',
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      padding: '20px 30px',
    },
    [theme.breakpoints.up('md')]: {
      padding: hasInnerPadding ? '20px 60px' : 0,
    },
  }),
}));

function Container({ children, className, hasInnerPadding = true, isCentered = false }) {
  const classes = useStyles({ hasInnerPadding, isCentered });
  return (
    <div className={classes.outerContainer}>
      <div className={clsx(classes.innerContainer, className)}>{children}</div>
    </div>
  );
}

export default Container;
